<div class="scopes-details-wrapper">
	<div class="client-property-label">
		@if (is27x01Product) {
			<span>{{ 'product-details.scope-details.certification-scope' | translate }}</span>
		}
		@if (!is27x01Product) {
			<span>{{ 'product-details.scope-details.iaf-scopes-questions' | translate }}</span>
		}
		<change-label [visible]="isScopeAddedOrRemoved()" [changeSet]="changeSet"></change-label>
	</div>
	<div id="scopes-{{standard.toLowerCase()}}" class="client-property">
		@for (scope of scopes; track scope.code; let isLast = $last) {
			<span>
        {{ scope.code + ' - ' + scope.name }}{{ isLast ? '&nbsp;' : ',&nbsp;' }}
      </span>
		}
	</div>

	@if (product.scopeDescriptionNeedsNarrowing) {
		<div class="client-property-label">
			<span>{{ 'product-details.scope-details.employees-within-scope' | translate }}</span>
			<change-label [visible]="isNumberOfEmployeesWithinScopeChanged()" [changeSet]="changeSet"></change-label>
		</div>
	}
	<div id="number-of-employees-{{standard}}" class="client-property">
		{{ product.employeesWithinScope }}
	</div>

	@for (scope of scopes; track scope.code) {
		@if (notEmpty(scope.questions)) {
			<div class="client-property-label">
				{{ scope.code.toUpperCase() + ' - ' + scope.name.toUpperCase() }}
			</div>
			@for (question of scope.questions; track question.text) {
				<div>
					<div class="scope-question-wrapper form-row with-padding-bottom radio-row">
						<div class="radio-column">
							<nb-radio id="scope-question-{{question.type.toLowerCase()}}"
									  [name]="question.type + randomNumber()" [checked]="true" status="primary">
								{{ question.answer | booleanDisplay }}
							</nb-radio>
						</div>
						<div class="radio-description-column">
							{{ question.text }}
							<change-label [visible]="isScopeQuestionChanged(scope.code, question.type)"
										  [changeSet]="changeSet"></change-label>
						</div>
					</div>
				</div>
			}
		}
	}
	@if (is9001Product && showCatastrophicRisk()) {
		<div class="catastrophe-risk-div form-row radio-row">
			<div class="radio-column">
				<nb-radio id="catastrophicRisk-{{standard}}" [checked]="true" status="primary"
						  [name]="'catastrophicRisk-' + standard + '-' + randomNumber()">
					{{ product.catastrophicRisk | booleanDisplay }}
				</nb-radio>
			</div>
			<div class="radio-description-column">
				{{ 'product-details.scope-details.catastrophic-risk-question' | translate }}
				<change-label [visible]="isCatastrophicRiskChanged()" [changeSet]="changeSet"></change-label>
			</div>
		</div>
	}
</div>
